import { ProductImpressionTrackingInfo } from "@omni/types/components/tracking/tracking-info/impression/productImpression.trackingInfo";

import { TypedAnalyticsEvent } from "@/services/tracking/types/analyticsEvent";

import { GoogleAnalyticsEvents } from "../GoogleAnalyticsEvents";
import {
    GoogleAnalyticsMinimumDataset,
    getPageInfo,
    getUserInfo
} from "../GoogleAnalyticsMinimumDataset";
import {
    GoogleAnalyticsProduct,
    getGoogleAnalyticsProduct
} from "./GoogleAnalyticsProduct";

export interface GoogleAnalyticsProductDetailImpression
    extends GoogleAnalyticsMinimumDataset {
    ecommerce: {
        detail: {
            actionField?: {
                list?: string;
            };
            products: GoogleAnalyticsProduct[];
        };
    };
}

const getGoogleAnalyticsProductDetailImpression = (
    data: TypedAnalyticsEvent<ProductImpressionTrackingInfo>
): GoogleAnalyticsProductDetailImpression => {
    return {
        event: GoogleAnalyticsEvents.ProductDetailImpression,
        pageInfo: getPageInfo(data),
        userInfo: getUserInfo(data),
        ecommerce: {
            detail: {
                actionField: {},
                products: [getGoogleAnalyticsProduct(data.payload.eventData)]
            }
        }
    };
};

export { getGoogleAnalyticsProductDetailImpression };
